import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl';

export function useMobile(breakpoint: Breakpoint = 'md') {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
}
